import { Icon } from '@iconify/react';
import React from 'react';

import { PATH_DASHBOARD } from 'routes/paths';
import { IGroup } from '@customTypes/group';

const getSidebarConfig = (selectedGroup?: IGroup) => [
    {
        subheader: 'general',
        items: [
            {
                title: 'dashboard',
                path: PATH_DASHBOARD.general.modules,
                icon: <Icon icon='ic:round-dashboard' width='48' height='48' />,
            },
            {
                title: 'my_studies',
                accessibleRoles: ['child'],
                path: PATH_DASHBOARD.studies.root,
                icon: <Icon icon='ic:round-account-box' width='48' height='48' />,
                children: [
                    { title: 'schedule', path: PATH_DASHBOARD.studies.schedule },
                    { title: 'attendance', path: PATH_DASHBOARD.studies.attendance },

                    ...(selectedGroup?.space_odyssey_enabled !== false
                        ? [{ title: 'space_odyssey', path: PATH_DASHBOARD.studies.points }]
                        : []),
                    ...(selectedGroup?.diploma_enabled !== false
                        ? [{ title: 'diploma', path: PATH_DASHBOARD.studies.diploma }]
                        : []),
                    ...(selectedGroup?.feedback_enabled !== false
                        ? [{ title: 'feedback', path: PATH_DASHBOARD.studies.feedback }]
                        : []),
                ],
            },
            {
                title: 'space_odyssey',
                accessibleRoles: ['parent'],
                path: PATH_DASHBOARD.points.root,
                icon: <Icon icon='ic:round-rocket' width='48' height='48' />,
            },
            {
                title: 'feedback',
                accessibleRoles: ['parent'],
                path: PATH_DASHBOARD.studies.feedback,
                icon: <Icon icon='ic:round-feedback' width='48' height='48' />,
            },
            {
                title: 'diploma',
                accessibleRoles: ['parent'],
                path: PATH_DASHBOARD.studies.diploma,
                icon: <Icon icon='ic:round-school' width='48' height='48' />,
            },
            {
                title: 'schedule',
                accessibleRoles: ['admin', 'teacher'],
                path: PATH_DASHBOARD.schedule.root,
                icon: <Icon icon='ic:round-calendar-today' width='48' height='48' />,
            },
            {
                title: 'attendance',
                accessibleRoles: ['admin', 'teacher'],
                path: PATH_DASHBOARD.attendance.root,
                icon: <Icon icon='ic:round-edit-calendar' width='48' height='48' />,
            },
            {
                title: 'analytics',
                accessibleRoles: ['admin'],
                path: PATH_DASHBOARD.analytics.root,
                icon: <Icon icon='ic:round-analytics' width='48' height='48' />,
            },
            {
                title: 'teacher_prizes',
                accessibleRoles: ['teacher', 'admin'],
                path: PATH_DASHBOARD.teacherPrizes.root,
                icon: <Icon icon='ic:round-emoji-events' width='48' height='48' />,
            },
        ],
    },
    {
        subheader: 'management',
        items: [
            {
                title: 'groups',
                accessibleRoles: ['admin', 'teacher'],
                path: PATH_DASHBOARD.groups.root,
                icon: <Icon icon='ic:round-groups' width='48' height='48' />,
            },
            {
                title: 'users',
                accessibleRoles: ['admin'],
                path: PATH_DASHBOARD.users.root,
                icon: <Icon icon='ic:round-group' width='48' height='48' />,
            },
            {
                title: 'children',
                accessibleRoles: ['parent'],
                path: PATH_DASHBOARD.children.root,
                icon: <Icon icon='ic:round-group' width='48' height='48' />,
            },
        ],
    },
    {
        subheader: 'settings',
        items: [
            {
                title: 'account',
                path: PATH_DASHBOARD.account.root,
                icon: <Icon icon='ic:round-account-box' width='48' height='48' />,
            },
        ],
    },
];

export default getSidebarConfig;
